import { storageData } from "services/Services"

const returnQuestionID = (state) => {
    var questionIdObj = {
        "MI": "105",
        "NJ": "21",
        "PA": "81"
    }
    return questionIdObj[state]
}

const OtherDeductibleList = ({ state = "" }) => {
    let options = []
    try {
        const dropdownOptions = JSON.parse(storageData.getItem('DropdownOptions'))
        let deductibleOptions = dropdownOptions.rows.filter(row => row.QuestionID == returnQuestionID(state))

        if (deductibleOptions.length > 0) {
            options = [
                <option key="default" disabled value="">Select from the following...</option>,
                ...deductibleOptions.map(answer => (
                    <option key={answer.AnswerID} value={answer.AnswerText}>{answer.AnswerText}</option>
                ))
            ]
        }
    } catch (error) {
        console.error(error)
        options = [<option key="default" value="">Select from the following...</option>]
    }

    return <>{options}</>
}

export default OtherDeductibleList